import { putApi } from "../apis/index";
export const updateUser = (id, json) => {
    return putApi(`/api/users/profile/${id}`, json);
};